import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

const PersonalInfo = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [loading, setLoading] = useState(false);

  // ⭐ Auto-load mobile number from session storage
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    try {
      const storedMobile = sessionStorage.getItem("login_mobile");
      if (storedMobile) {
        setMobile(storedMobile);
      }
    } catch {
      setMobile(""); // fallback
    }
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          sessionStorage.setItem("auth", "true");
          navigate("/");
          window.location.reload();
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert("Failed to send email. Try again.");
        },
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
        padding: "16px",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          width: "100%",
          maxWidth: "450px",
          padding: "30px 25px",
          position: "relative",
          boxShadow: "0 5px 25px rgba(0,0,0,0.2)",
        }}
      >
        {/* Close button */}
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            border: "none",
            background: "none",
            fontSize: "22px",
            cursor: "pointer",
            color: "#666",
          }}
          onClick={() => navigate("/")}
        >
          &times;
        </button>

        <h3
          style={{
            textAlign: "center",
            fontWeight: "600",
            fontSize: "18px",
            marginBottom: "20px",
            color: "#222",
          }}
        >
          Personal Information
        </h3>

        {/* EmailJS Form */}
        <form
          ref={form}
          onSubmit={sendEmail}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {/* Full Name */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                marginBottom: "6px",
                color: "#333",
                display: "flex",
                alignItems: "center",
              }}
            >
              Enter Your Full Name
              <span style={{ color: "red", marginLeft: "3px" }}>*</span>
            </label>

            <input
              type="text"
              name="from_name"
              placeholder="Name"
              required
              style={inputStyle}
            />
          </div>

          {/* Email */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                marginBottom: "6px",
                color: "#333",
                display: "flex",
                alignItems: "center",
              }}
            >
              Enter Your Email ID
              <span style={{ color: "red", marginLeft: "3px" }}>*</span>
            </label>
            <input type="email" name="from_email" required style={inputStyle} />
          </div>

          {/* Mobile Number (⭐ auto-filled from session) */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                marginBottom: "6px",
                color: "#333",
                display: "flex",
                alignItems: "center",
              }}
            >
              Mobile Number
              <span style={{ color: "red", marginLeft: "3px" }}>*</span>
            </label>
            <input
              type="tel"
              name="mobileNumber"
              maxLength="10"
              placeholder="Mobile Number"
              required
              readOnly
              style={inputStyle}
              value={mobile}
              onChange={(e) =>
                setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))
              }
            />
          </div>

          {/* Company */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                marginBottom: "6px",
                color: "#333",
                display: "flex",
                alignItems: "center",
              }}
            >
              Company Name
              <span style={{ color: "red", marginLeft: "3px" }}>*</span>
            </label>
            <input type="text" name="need" required style={inputStyle} />
          </div>

          {/* Message */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{
                fontSize: "14px",
                marginBottom: "6px",
                color: "#333",
                display: "flex",
                alignItems: "center",
              }}
            >
              Message
            </label>
            <input
              type="text"
              name="message"
              placeholder="What is your need"
              style={inputStyle}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              backgroundColor: loading ? "#6c757d" : "#0d6efd",
              color: "#fff",
              border: "none",
              padding: "10px",
              borderRadius: "6px",
              fontWeight: "500",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "15px",
              marginTop: "10px",
              transition: "0.3s",
            }}
          >
            {loading ? "Sending..." : "SUBMIT"}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  border: "1px solid #ccc",
  borderRadius: "6px",
  padding: "10px 12px",
  fontSize: "14px",
  outline: "none",
};

export default PersonalInfo;
